'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dGroup$002dRestrictions$002dView$0024$0024anon$002463 from "./presto.-Group-Restrictions-View$$anon$63.js";
import * as $j_presto$002etypes$0024$002dAccount$002dId$0024 from "./presto.types$-Account-Id$.js";
import * as $j_presto$002etypes$0024$002dGrouping$0024 from "./presto.types$-Grouping$.js";
import * as $j_presto$002etypes$0024$002dGrouping$002dDescription$0024 from "./presto.types$-Grouping-Description$.js";
import * as $j_presto$002etypes$0024$002dGrouping$002dId$0024 from "./presto.types$-Grouping-Id$.js";
import * as $j_presto$002etypes$0024$002dGrouping$002dKind$0024 from "./presto.types$-Grouping-Kind$.js";
import * as $j_presto$002etypes$0024$002dGrouping$002dName$0024 from "./presto.types$-Grouping-Name$.js";
var $p;
/** @constructor */
function $c_Lpresto_GroupRestrictionsView$$anon$62() {
  this.aVs = null;
  this.aVk = null;
  this.aVl = false;
  this.aVt = null;
  this.aVu = false;
  this.aVx = null;
  this.aVq = null;
  this.aVr = false;
  this.aVm = null;
  this.aVn = false;
  this.aVo = null;
  this.aVp = false;
  this.aVv = false;
  this.aVw = false;
  this.aVs = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.aVx = "Grouping";
}
export { $c_Lpresto_GroupRestrictionsView$$anon$62 as $c_Lpresto_GroupRestrictionsView$$anon$62 };
$p = $c_Lpresto_GroupRestrictionsView$$anon$62.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_GroupRestrictionsView$$anon$62;
/** @constructor */
function $h_Lpresto_GroupRestrictionsView$$anon$62() {
}
export { $h_Lpresto_GroupRestrictionsView$$anon$62 as $h_Lpresto_GroupRestrictionsView$$anon$62 };
$h_Lpresto_GroupRestrictionsView$$anon$62.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.aVs;
});
$p.L = (function() {
  if ((!this.aVl)) {
    this.aVk = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.aVl = true;
  }
  return this.aVk;
});
$p.O = (function() {
  if ((!this.aVu)) {
    this.aVt = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.aVu = true;
  }
  return this.aVt;
});
$p.E = (function() {
  return this.aVx;
});
$p.t = (function() {
  if ((!this.aVr)) {
    this.aVq = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("id", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("created", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("account", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("kind", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("name", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("description", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))))));
    this.aVr = true;
  }
  return this.aVq;
});
$p.M = (function() {
  if ((!this.aVn)) {
    this.aVm = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dGrouping$002dId$0024.$m_Lpresto_types$GroupingId$().nK(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().Z(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dAccount$002dId$0024.$m_Lpresto_types$AccountId$().bl(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder($j_presto$002etypes$0024$002dGrouping$002dKind$0024.$m_Lpresto_types$GroupingKind$().p4())), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dGrouping$002dName$0024.$m_Lpresto_types$GroupingName$().nL(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dGrouping$002dDescription$0024.$m_Lpresto_types$GroupingDescription$().p3(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))))));
    this.aVn = true;
  }
  return this.aVm;
});
$p.Q = (function() {
  if ((!this.aVp)) {
    this.aVo = new $j_presto$002e$002dGroup$002dRestrictions$002dView$0024$0024anon$002463.$c_Lpresto_GroupRestrictionsView$$anon$63();
    this.aVp = true;
  }
  return this.aVo;
});
$p.w = (function() {
  if ((!this.aVw)) {
    this.aVv = false;
    this.aVw = true;
  }
  return this.aVv;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee471) => ((p) => \u03b4scrutinee471.p0(p)))($j_presto$002etypes$0024$002dGrouping$0024.$m_Lpresto_types$Grouping$())));
});
var $d_Lpresto_GroupRestrictionsView$$anon$62 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_GroupRestrictionsView$$anon$62, "presto.GroupRestrictionsView$$anon$62", ({
  J7: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_GroupRestrictionsView$$anon$62 as $d_Lpresto_GroupRestrictionsView$$anon$62 };
//# sourceMappingURL=presto.-Group-Restrictions-View$$anon$62.js.map
